<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            <back-button :link="`/training-videos`"></back-button> 
            Training Videos of Course {{ course.course_name }}
            <add-button :link="`/training-videos/${course.id}/details/create`"></add-button>
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">Training Videos</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->
      
      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Title</th>
                        <th>Description</th>
                        <th>No of Hrs</th>
                        <th>Video Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table :isLoading="isLoading" cols="8"></loading-table>
                      <router-link 
                        v-for="(detail, at) in course_details"
                        :key="`detail${at}`"
                        :to="`/training-videos/${course.id}/details/${detail.id}`"
                        tag="tr"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ detail.title || '' }}</td>
                        <td>{{ detail.description }}</td>
                        <td>{{ detail.no_of_hrs }}</td>
                        <td>{{ detail.videolink }}</td>
                      </router-link>
                    </tbody>
                  </table>
                </div>
                <pagination :count="count" @submit="getData"></pagination>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'trainingVideoDetails',
  data () {
    return {
      course: [],
      course_details: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true
      let course = await axios.get(`/courses/${this.$route.params.trainingVideoId}`)
      this.course = course.data.data
      let course_details = await axios.get(`/courses/${this.$route.params.trainingVideoId}/course_details?page=${page}&rowsPerPage=${this.rowsPerPage}&search=all`)
      this.course_details = course_details.data.data
      this.count = course_details.data.count
      this.serialNoStarting = (page - 1) * this.rowsPerPage
      this.isLoading = false
    }
  }
}
</script>